import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({endPoint: `Login`, method: 'POST', body, token})
}
